import { MilestonesGridData } from '../types';
import { useSortByName } from './useSortByName';
import { useSortByDate } from './useSortByDate';
import { useSortByTier } from './useSortByTier';

/**
 * Consolidated hook that applies column-specific sorting to milestones data
 * Applied AFTER filtering for better performance
 *
 * Sorting order (only ONE column can be sorted at a time):
 * 1. Name column (alphabetical or risk-based)
 * 2. Date column (ascending/descending)
 * 3. Tier column (ascending/descending)
 *
 * Each sorting hook checks if its column has active selections
 * If not, it returns data unchanged and passes to the next hook
 */
export const useSortedMilestones = (
  data: MilestonesGridData | null
): MilestonesGridData | null => {
  // Apply sorts sequentially - only the first active sort will modify the data
  // Others will pass through unchanged
  const nameSorted = useSortByName(data);
  const dateSorted = useSortByDate(nameSorted);
  const tierSorted = useSortByTier(dateSorted);

  return tierSorted;
};
